<template>
    <div>
        <modal
            class="new-modal-small save-call-report"
            :name="modal_name"
            transition="nice-modal-fade"
            :delay="100"
            height="auto"
            :min-height="200"
            :min-width="400"
            :pivot-y="0.5"
            :adaptive="true"
            :scrollable="false"
            style="pointer-events:inherit !important" 
            v-bind:click-to-close="false"
        >
            <div class="v-modal-content d-flex flex-column justify-content-center align-items-center text-center p-6" style="background-color: #dfe8f4 !important;">
                <img src="/static/images/parrot.svg" style="height: 10rem !important" />
                <div class="mt-5">
                    <div class="mb-4" style="font-size: 18px;">Success</div>
                    Your Call Report has been successfully sent
                    <div class="my-4" style="font-size: 18px;">Call Report Number</div>
                    <img src="https://cdn.digicollect.com/cdn/scmnew/images/scm/qr.svg" alt="" style="width:80px">
                    <div class="mb-4" style="font-size: 20px; color: #003cb9;">{{call_report_number}}</div>
                </div>
                <div class="d-flex aligin-items-center justify-content-center mt-6">
                    <button
                        type="button"
                        class="btn btn-new-primary btn-smm"
                        style="box-shadow: none;min-width: 5rem;"
                        @click="hideSelf"
                    >Ok</button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
export default {
    props: ["modal_name","call_report_number"],
    methods: {
        hideSelf() {
            this.$modal.hide(this.modal_name);
            // this.$router.push("/callreportlist");
            // localStorage.removeItem("callReportReviewData");
            // localStorage.removeItem("internalCompanyObject");
            // localStorage.removeItem("attachments");
            this.$emit("afterSave")
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/alertModals/SaveCallReport.vue